import * as React from "react"
import { isEmpty as _isEmpty } from "lodash"
import { Route, IndexRoute } from "react-router";
import Main from "./containers/Main"
import NotFoundPage from "./components/NotFoundPage";
import DoctorProfilePage from "./containers/DoctorProfilePage";
import PatientConsultationDetail from "./containers/Patient/PatientConsultationDetailContainer"
import PatientContainer from "./containers/PatientContainer"
import MyPatientsPage from "./containers/MyPatientsPage"
import PatientVitalContainer from "./containers/Patient/PatientVitalContainer"
import PatientLifestyleContainer from "./containers/Patient/PatientLifestyleContainer"
import PatientMedicalHistoryContainer from "./containers/Patient/PatientMedicalHistoryContainer"
import PatientLabTestsContainer from "./containers/Patient/PatientLabTestsContainer"
import OngoingConsultationContainer from "./containers/Ongoing/OngoingConsultationContainer"
import PatientConsultationsContainer from "./containers/Patient/PatientConsultationsContainer"
import { browserHistory } from "react-router"
import AccessControlComponent from "./components/utils/AccessControlComponent";
import DashboardPage from "./containers/DashboardPage";
import PatientNotesOOCContainer from "./containers/Patient/PatientNotesOOCContainer";
import { Roster } from "./containers/Roster";
import AllPatientsSearchPage from "./containers/AllPatientsSearchPage";
import PatientConsultationEditContainer from "./containers/Patient/PatientConsultationEditContainer";
import TreatmentPlansPage from "./containers/TreatmentPlansPage";
import CreateTreatmentPlanContainer from "./containers/CreateTreatmentPlanContainer";
import { AppConstants } from "./utils/AppConstants";
import { Tracker } from "./utils/Tracker";
import { EventNames } from "./utils/EventTrackerConstants";
import DefaultWorkingHoursContainer from "./containers/DefaultWorkingHours";
import ResumeExperience from "./containers/ResumePage";
import PatientTransformContainer from "./containers/Patient/Transform/PatientTransformContainer";

import FitnessPlanTemplate from "./containers/FitnessPlan/FitnessTemplate/FitnessTemplate";
import FitnessPlanList from "./containers/FitnessPlan/AllFitnessPlans/AllFitnessPlans";
import AGPReportContainer from "./containers/AGPReportContainer";
import { InterventionsContainer } from "./containers/InterventionsContainer";
import { SugarJournalContainer } from "./containers/SugarJournalContainer";

export const EDIT = "/edit";
export const RECOMMENDED = "recommended"
// ROUTE_PARAMS:
export const PATIENT_ID_PARAM = "patientId";
export const DOCTOR_ID_PARAM = "doctorId";
export const CONSULTATION_ID_PARAM = "consultationId";
export const LABTEST_ID_PARAM = "consultationId";
export const USER_ID_PARAM = "userId"
export const TEMPLATE_ID_PARAM = "templateId";
export const FITNESS_TEMPLATE_ID_PARAM = "fitnessTemplateId";

export const ROUTE_PARAMS_SEPARATOR = ":";
export const ROUTE_PATH_SEPARATOR = "/";
export const PATIENT_PATH = "/patient"

// ROUTE NAMES:
export const HOME_PAGE_ROUTE = "/";
export const DOC_PROFILE = HOME_PAGE_ROUTE + "profile";
export const DOC_DASHBOARD = HOME_PAGE_ROUTE + "dashboard";
export const DOCTOR_CONSULTATIONS = HOME_PAGE_ROUTE + "patients";
export const TREATMENT_PLANS = HOME_PAGE_ROUTE + "treatmentPlans";
export const DOCTOR_PATIENTS = HOME_PAGE_ROUTE + "myPatients";

export const PATIENT_PROFILE = HOME_PAGE_ROUTE + "patient" + ROUTE_PATH_SEPARATOR + ROUTE_PARAMS_SEPARATOR + PATIENT_ID_PARAM;
export const PATIENT_CONSULTATIONS = PATIENT_PROFILE + ROUTE_PATH_SEPARATOR + "consultations";
export const PATIENT_CONSULTATION_DETAILS = PATIENT_CONSULTATIONS + ROUTE_PATH_SEPARATOR + ROUTE_PARAMS_SEPARATOR + CONSULTATION_ID_PARAM;
export const ONGOING_CONSULTATION_PATH = PATIENT_PROFILE + "/consultation/" + ROUTE_PARAMS_SEPARATOR + CONSULTATION_ID_PARAM + "/ongoing";
export const EDIT_PRESCRIPTION_PATH = PATIENT_CONSULTATION_DETAILS + EDIT;

export const PATIENT_LABTESTS = PATIENT_PROFILE + ROUTE_PATH_SEPARATOR + "labtests";
export const PATIENT_LABTEST_DETAILS = PATIENT_LABTESTS + ROUTE_PATH_SEPARATOR + ROUTE_PARAMS_SEPARATOR + LABTEST_ID_PARAM;
export const PATIENT_MEDICAL_HISTORY = PATIENT_PROFILE + ROUTE_PATH_SEPARATOR + "medicalhistory";
export const PATIENT_VITALS_VIEW = PATIENT_PROFILE + ROUTE_PATH_SEPARATOR + "vitals";
export const PATIENT_LIFESTYLES = PATIENT_PROFILE + ROUTE_PATH_SEPARATOR + "lifestyles";
export const PATIENT_NOTES = PATIENT_PROFILE + ROUTE_PATH_SEPARATOR + "patientNotes";
export const AGP_REPORTS = PATIENT_PROFILE + ROUTE_PATH_SEPARATOR + "agpReports";
export const INTERVENTIONS = PATIENT_PROFILE + ROUTE_PATH_SEPARATOR + "interventions";
export const SUGAR_JOURNAL = PATIENT_PROFILE + ROUTE_PATH_SEPARATOR + "sugar-journal";
export const ROSTER = HOME_PAGE_ROUTE + "roster";
export const RESUME_ROUTE = HOME_PAGE_ROUTE + "resume";
export const PATIENT_TRANSFORM = PATIENT_PROFILE + ROUTE_PATH_SEPARATOR + "transform";

export const TREATMENT_PLANS_ADD = TREATMENT_PLANS + ROUTE_PATH_SEPARATOR + "add";
export const TREATMENT_PLANS_FROM_CONSULT = TREATMENT_PLANS + ROUTE_PATH_SEPARATOR + ROUTE_PARAMS_SEPARATOR + CONSULTATION_ID_PARAM + ROUTE_PATH_SEPARATOR + ROUTE_PARAMS_SEPARATOR + PATIENT_ID_PARAM + ROUTE_PATH_SEPARATOR + "fromConsult";
export const TREATMENT_PLANS_EDIT = TREATMENT_PLANS + EDIT + ROUTE_PATH_SEPARATOR + ROUTE_PARAMS_SEPARATOR + TEMPLATE_ID_PARAM;
export const DEFAULT_WORKING_HOURS = ROSTER + ROUTE_PATH_SEPARATOR + "automatedWorkingHours";

export const TREATMENT_PLANS_RECO = TREATMENT_PLANS + EDIT + ROUTE_PATH_SEPARATOR + RECOMMENDED + ROUTE_PATH_SEPARATOR + ROUTE_PARAMS_SEPARATOR + TEMPLATE_ID_PARAM + PATIENT_PATH + ROUTE_PATH_SEPARATOR + ROUTE_PARAMS_SEPARATOR + PATIENT_ID_PARAM;

/********* Fitness Plan Routes  **********/
export const FITNESS_PLAN = HOME_PAGE_ROUTE + "fitness-plan";
export const FITNESS_PLAN_CREATE = FITNESS_PLAN + "/create";
export const FITNESS_PLAN_CREATE_USER_PLAN = FITNESS_PLAN_CREATE + ROUTE_PATH_SEPARATOR + "user" + ROUTE_PATH_SEPARATOR + ROUTE_PARAMS_SEPARATOR + USER_ID_PARAM;
export const FITNESS_PLAN_EDIT = FITNESS_PLAN + ROUTE_PATH_SEPARATOR + "edit" + ROUTE_PATH_SEPARATOR + ROUTE_PARAMS_SEPARATOR + FITNESS_TEMPLATE_ID_PARAM;
export const FITNESS_PLAN_VIEW = FITNESS_PLAN + ROUTE_PATH_SEPARATOR + "view" + ROUTE_PATH_SEPARATOR + ROUTE_PARAMS_SEPARATOR + FITNESS_TEMPLATE_ID_PARAM;
export const FITNESS_PLAN_EDIT_USER_PLAN = FITNESS_PLAN_EDIT + ROUTE_PATH_SEPARATOR + "user" + ROUTE_PATH_SEPARATOR + ROUTE_PARAMS_SEPARATOR + USER_ID_PARAM;
/******************************************/

export interface AccessConfig {
    routePath?: string,
    hasAccess: boolean,
    childrenMap?: { [key: string]: AccessConfig },
    component?: string
}

export const NurseAccessConfig: AccessConfig = {
    routePath: "/",
    hasAccess: true,
    childrenMap: {
        dashboard: {
            routePath: "dashboard",
            hasAccess: true
        },
        roster: {
            routePath: "roster",
            hasAccess: false,
        },
        profile: {
            routePath: "profile",
            hasAccess: true
        },
        patient: {
            routePath: "patient",
            hasAccess: true,
            childrenMap: {
                consultation: {
                    routePath: "consultation",
                    hasAccess: false,
                    childrenMap: {
                        ongoing: {
                            routePath: "ongoing",
                            hasAccess: false
                        }
                    }
                },
                consultations: {
                    routePath: "consultations",
                    hasAccess: true,
                    childrenMap: {
                        edit: {
                            routePath: "edit",
                            hasAccess: true
                        }
                    }
                },
                labtests: {
                    routePath: "labtests",
                    hasAccess: true
                },
                vitals: {
                    routePath: "vitals",
                    hasAccess: true,
                },
                medicalhistory: {
                    routePath: "medicalhistory",
                    hasAccess: false
                },
                lifestyles: {
                    routePath: "lifestyles",
                    hasAccess: false
                },
                patientNotes: {
                    routePath: "patientNotes",
                    hasAccess: false
                }
            }
        },
        patients: {
            routePath: "patients",
            hasAccess: true,
        }
    },
};

export const DoctorAccessConfig: AccessConfig = {
    routePath: "/",
    hasAccess: true,
    childrenMap: {
        dashboard: {
            routePath: "dashboard",
            hasAccess: true
        },
        roster: {
            routePath: "roster",
            hasAccess: true,
        },
        profile: {
            routePath: "profile",
            hasAccess: true
        },
        patient: {
            routePath: "patient",
            hasAccess: true,
            childrenMap: {
                consultation: {
                    routePath: "consultation",
                    hasAccess: true,
                    childrenMap: {
                        ongoing: {
                            routePath: "ongoing",
                            hasAccess: true
                        }
                    }
                },
                consultations: {
                    routePath: "consultations",
                    hasAccess: true,
                    childrenMap: {
                        edit: {
                            routePath: "edit",
                            hasAccess: true
                        }
                    }
                },
                labtests: {
                    routePath: "labtests",
                    hasAccess: true
                },
                vitals: {
                    routePath: "vitals",
                    hasAccess: true,
                },
                medicalhistory: {
                    routePath: "medicalhistory",
                    hasAccess: true
                },
                lifestyles: {
                    routePath: "lifestyles",
                    hasAccess: true
                },
                patientNotes: {
                    routePath: "patientNotes",
                    hasAccess: true
                },
                transform: {
                    routePath: "transform",
                    hasAccess: true
                },
                agpReports: {
                    routePath: "agpReports",
                    hasAccess: true
                },
                interventions: {
                    routePath: "interventions",
                    hasAccess: true
                },
                "sugar-journal": {
                    routePath: "sugar-journal",
                    hasAccess: true
                }
            }
        },
        patients: {
            routePath: "patients",
            hasAccess: true,
        },
        myPatients: {
            routePath: "myPatients",
            hasAccess: true
        },
        treatmentPlans: {
            routePath: "treatmentPlans",
            hasAccess: true,
            childrenMap: {
                add: {
                    routePath: "add",
                    hasAccess: true
                },
                fromConsult: {
                    routePath: "fromConsult",
                    hasAccess: true
                },
                edit: {
                    routePath: "edit",
                    hasAccess: true,
                    childrenMap: {
                        recommended: {
                            routePath: "/recommended",
                            hasAccess: true,
                            childrenMap: {
                                patient: {
                                    routePath: "/patient",
                                    hasAccess: true,
                                }
                            }
                        }
                    }
                }
            }
        },
        "fitness-plan": {
            routePath: "fitness-plan",
            hasAccess: true,
            childrenMap: {
                create: {
                    routePath: "create",
                    hasAccess: true,
                    childrenMap: {
                        user: {
                            routePath: "user",
                            hasAccess: true
                        }
                    }
                },
                edit: {
                    routePath: "edit",
                    hasAccess: true,
                    childrenMap: {
                        user: {
                            routePath: "user",
                            hasAccess: true
                        }
                    }
                },
                view: {
                    routePath: "view",
                    hasAccess: true
                }
                // fromConsult: {
                //     routePath: "fromConsult",
                //     hasAccess: true
                // },
                // edit: {
                //     routePath: "edit",
                //     hasAccess: true,
                //     childrenMap: {
                //         recommended: {
                //             routePath: "/recommended",
                //             hasAccess: true,
                //             childrenMap: {
                //                 patient: {
                //                     routePath: "/patient",
                //                     hasAccess: true,
                //                 }
                //             }
                //         }
                //     }
                // }
            }
        }
    },
}

export interface NavConfig {
    id: string,
    url: string,
    label: string,
    featureEnabledKey?: string,
    visibilityOn?: string,
}

export const APP_TOP_NAVS: NavConfig[] = [
    { id: "calendar", url: DOC_DASHBOARD, label: "Calendar" },
    { id: "patients", url: DOCTOR_PATIENTS, label: "My Patients" },
    { id: "roster", url: ROSTER, label: "Working Hours" },
    { id: "consultations", url: DOCTOR_CONSULTATIONS, label: "Consultations" },
    { id: "treatmentPlans", url: TREATMENT_PLANS, label: "Treatment Plans", featureEnabledKey: "OrionEnablePrescriptionTemplate" }
];

export const PATIENT_NAVS: NavConfig[] = [
    { id: "consultations", url: PATIENT_CONSULTATIONS, label: "Consultations" },
    { id: "lab-tests", url: PATIENT_LABTESTS, label: "Lab Tests" },
    // {id: "medical-history", url: PATIENT_MEDICAL_HISTORY, label: "Medical History"},
    { id: "vitals", url: PATIENT_VITALS_VIEW, label: "Vitals" },
    { id: "lifestyle-plan", url: PATIENT_LIFESTYLES, label: "Lifestyle Plan" },
    { id: "consultations", url: PATIENT_NOTES, label: "Patient Notes" },
    { id: "agp-reports", url: AGP_REPORTS, label: "AGP Reports", visibilityOn: "SUGARFIT" },
    { id: "interventions", url: INTERVENTIONS, label: "Interventions", visibilityOn: "SUGARFIT" },
    { id: "sugar-journal", url: SUGAR_JOURNAL, label: "Sugar Journal", visibilityOn: "SUGARFIT" }
];

export const TRANSFORM_PATIENT_NAVS: NavConfig[] = [
    { id: "transform", url: PATIENT_TRANSFORM, label: "Transform Plan" },
    { id: "consultations", url: PATIENT_CONSULTATIONS, label: "Consultations" },
    // { id: "lab-tests", url: PATIENT_LABTESTS, label: "Lab Tests" },
    { id: "lifestyle-plan", url: PATIENT_LIFESTYLES, label: "Lifestyle Plan" },
    // { id: "consultations", url: PATIENT_NOTES, label: "Patient Notes" }
];

export const TRANSFORM_TOP_NAVS: NavConfig[] = [
    { id: "calendar", url: DOC_DASHBOARD, label: "Calendar" },
    { id: "patients", url: DOCTOR_PATIENTS, label: "My Clients" },
    { id: "fitness-plan", url: FITNESS_PLAN, label: "Fitness Plan" },
    { id: "roster", url: ROSTER, label: "Working Hours" },
    // { id: "consultations", url: DOCTOR_CONSULTATIONS, label: "Consultations" },
    // { id: "treatmentPlans", url: TREATMENT_PLANS, label: "Treatment Plans", featureEnabledKey: "OrionEnablePrescriptionTemplate" }
];

export class RouteUtils {
    static getPatientConsultationDetailsUrl = (patientId: number, consultationId: number): string => {
        return PATIENT_CONSULTATION_DETAILS.replace(ROUTE_PARAMS_SEPARATOR + PATIENT_ID_PARAM, patientId.toString())
            .replace(ROUTE_PARAMS_SEPARATOR + CONSULTATION_ID_PARAM, consultationId.toString());
    }

    static getOngoingConsultationUrl = (patientId: number, consultationId: number): string => {
        return ONGOING_CONSULTATION_PATH.replace(ROUTE_PARAMS_SEPARATOR + PATIENT_ID_PARAM, patientId.toString())
            .replace(ROUTE_PARAMS_SEPARATOR + CONSULTATION_ID_PARAM, consultationId.toString());
    }

    static getAllConsultationsUrl = (patientId: number): string => {
        return PATIENT_CONSULTATIONS.replace(ROUTE_PARAMS_SEPARATOR + PATIENT_ID_PARAM, patientId.toString());
    }

    static getDefaultWorkingHoursUrl = () => {
        return DEFAULT_WORKING_HOURS;
    }

    static navigateToHrefUrl = (e: any, url: string): void => {
        RouteUtils.navigateToUrl(url);
        if (!_isEmpty(e)) e.preventDefault();
    }

    static navigateToUrl = (url: string): void => {
        browserHistory.push(url);
    }

    static navigateToDashboard = (): void => {
        browserHistory.push(DOC_DASHBOARD);
    }

    static navigateToConsultations = (): void => {
        browserHistory.push(DOCTOR_CONSULTATIONS);
    }

    static getEditTreatmentPlanUrl = (templateId: string) => {
        return TREATMENT_PLANS_EDIT.replace(ROUTE_PARAMS_SEPARATOR + TEMPLATE_ID_PARAM, templateId);
    }

    static getRecoTreatmentPlanUrl = (templateId: string, patientId: string) => {
        return TREATMENT_PLANS_RECO
            .replace(ROUTE_PARAMS_SEPARATOR + TEMPLATE_ID_PARAM, templateId)
            .replace(ROUTE_PARAMS_SEPARATOR + PATIENT_ID_PARAM, patientId);
    }

    static getFromConsultTreatmentPlanUrl = (consultationId: string, patientId: string) => {
        return TREATMENT_PLANS_FROM_CONSULT
            .replace(ROUTE_PARAMS_SEPARATOR + CONSULTATION_ID_PARAM, consultationId)
            .replace(ROUTE_PARAMS_SEPARATOR + PATIENT_ID_PARAM, patientId)
    }

    static getEditFitnessPlanUrl = (planId: string) => {
        return FITNESS_PLAN_EDIT.replace(ROUTE_PARAMS_SEPARATOR + FITNESS_TEMPLATE_ID_PARAM, planId);
    }

    static getViewFitnessPlanUrl = (planId: string) => {
        return FITNESS_PLAN_VIEW.replace(ROUTE_PARAMS_SEPARATOR + FITNESS_TEMPLATE_ID_PARAM, planId);
    }

    static getEditUserFitnessPlanUrl = (planId: string, userId: string) => {
        return FITNESS_PLAN_EDIT_USER_PLAN.replace(ROUTE_PARAMS_SEPARATOR + FITNESS_TEMPLATE_ID_PARAM, planId).replace(ROUTE_PARAMS_SEPARATOR + USER_ID_PARAM, userId);
    }

    static getCreateUserFitnessPlanUrl = (userId: string) => {
        return FITNESS_PLAN_CREATE_USER_PLAN.replace(ROUTE_PARAMS_SEPARATOR + USER_ID_PARAM, userId);
    }

}

const OnRouteChangeSetTime = () => {
    (window as any).loadStartTime = new Date().getTime()
}

let ongoingRouteEnterTime: number = undefined;

document.addEventListener(AppConstants.ONGOING_CONS_OPEN_EVENT, (e: CustomEvent) => {
    if (ongoingRouteEnterTime) {
        const loadtimeInMs = new Date().getTime() - ongoingRouteEnterTime;
        ongoingRouteEnterTime = undefined;
        console.log(`\n\n\n\nInstrumented load time as :  ${loadtimeInMs} Ms`);
        Tracker.track(EventNames.Page_Load, {
            flow: EventNames.Consultation,
            section: "",
            loadTime: Number(loadtimeInMs / 1000)
        });
    }
});





export default (
    <Route onChange={OnRouteChangeSetTime}>

        <Route path={HOME_PAGE_ROUTE} component={Main}>

            <IndexRoute component={AccessControlComponent} {...{ onSuccess: DashboardPage }} />
            <Route path={ROSTER} component={AccessControlComponent} {...{ onSuccess: Roster }} />

            <Route path={RESUME_ROUTE} component={ResumeExperience} />

            <Route path={DOC_DASHBOARD} component={AccessControlComponent} {...{ onSuccess: DashboardPage }} />

            <Route path={DOC_PROFILE} component={DoctorProfilePage} />

            <Route path={DOCTOR_CONSULTATIONS} component={AccessControlComponent} {...{ onSuccess: MyPatientsPage }} />

            <Route path={DOCTOR_PATIENTS} component={AccessControlComponent} {...{ onSuccess: AllPatientsSearchPage }} />

            <Route path={TREATMENT_PLANS} component={AccessControlComponent} {...{ onSuccess: TreatmentPlansPage }} />

            <Route path={TREATMENT_PLANS_ADD} component={AccessControlComponent} {...{ onSuccess: CreateTreatmentPlanContainer }} />

            <Route path={TREATMENT_PLANS_FROM_CONSULT} component={AccessControlComponent} {...{ onSuccess: CreateTreatmentPlanContainer }} />

            <Route path={TREATMENT_PLANS_EDIT} component={AccessControlComponent} {...{ onSuccess: CreateTreatmentPlanContainer }} />

            <Route path={DEFAULT_WORKING_HOURS} component={DefaultWorkingHoursContainer} />
            <Route path={TREATMENT_PLANS_RECO} component={AccessControlComponent} {...{ onSuccess: CreateTreatmentPlanContainer }} />

            <Route path={PATIENT_PROFILE} component={AccessControlComponent} {...{ onSuccess: PatientContainer }}>
                {/*<Route path={PATIENT_CONSULTATION_DETAILS} component={PatientConsultationDetail}/>*/}
                <Route path={PATIENT_CONSULTATION_DETAILS} component={AccessControlComponent} {...{ onSuccess: PatientConsultationDetail }} />
                <Route path={EDIT_PRESCRIPTION_PATH} component={AccessControlComponent} {...{ onSuccess: PatientConsultationEditContainer }} />
                <Route path={PATIENT_CONSULTATIONS} component={AccessControlComponent} {...{ onSuccess: PatientConsultationsContainer }}>
                    <Route path={PATIENT_CONSULTATION_DETAILS} component={AccessControlComponent} {...{ onSuccess: PatientConsultationDetail }} />
                </Route>
                <Route path={PATIENT_LABTESTS} component={AccessControlComponent} {...{ onSuccess: PatientLabTestsContainer }}>
                    <Route path={PATIENT_LABTEST_DETAILS} component={AccessControlComponent} {...{ onSuccess: PatientConsultationDetail }} />
                </Route>
                <Route path={PATIENT_VITALS_VIEW} component={AccessControlComponent} {...{ onSuccess: PatientVitalContainer }} />

                <Route path={PATIENT_MEDICAL_HISTORY} component={AccessControlComponent} {...{ onSuccess: PatientMedicalHistoryContainer }} />

                <Route path={PATIENT_LIFESTYLES} component={AccessControlComponent} {...{ onSuccess: PatientLifestyleContainer }} />
                <Route path={PATIENT_TRANSFORM} component={AccessControlComponent} {...{ onSuccess: PatientTransformContainer }} />

                <Route path={ONGOING_CONSULTATION_PATH} component={AccessControlComponent} {...{ onSuccess: OngoingConsultationContainer }}
                    onEnter={() => { ongoingRouteEnterTime = new Date().getTime() }} onLeave={() => { ongoingRouteEnterTime = undefined }} />
                <Route path={PATIENT_NOTES} component={AccessControlComponent} {...{ onSuccess: PatientNotesOOCContainer }} />
                <Route path={AGP_REPORTS} component={AccessControlComponent} {...{ onSuccess: AGPReportContainer }} />
                <Route path={INTERVENTIONS} component={AccessControlComponent} {...{ onSuccess: InterventionsContainer }} />
                <Route path={SUGAR_JOURNAL} component={AccessControlComponent} {...{ onSuccess: SugarJournalContainer }} />
            </Route>

            <Route path={FITNESS_PLAN} component={AccessControlComponent} {...{ onSuccess: FitnessPlanList }}>
            </Route>
            <Route path={FITNESS_PLAN_CREATE} component={AccessControlComponent} {...{ onSuccess: FitnessPlanTemplate }}></Route>
            <Route path={FITNESS_PLAN_EDIT} component={AccessControlComponent} {...{ onSuccess: FitnessPlanTemplate }}></Route>
            <Route path={FITNESS_PLAN_VIEW} component={AccessControlComponent} {...{ onSuccess: FitnessPlanTemplate }}></Route>
            <Route path={FITNESS_PLAN_EDIT_USER_PLAN} component={AccessControlComponent} {...{ onSuccess: FitnessPlanTemplate }}></Route>
            <Route path={FITNESS_PLAN_CREATE_USER_PLAN} component={AccessControlComponent} {...{ onSuccess: FitnessPlanTemplate }}></Route>

            <Route path="*" component={NotFoundPage} />


        </Route>
    </Route >
);

